module.exports = __webpack_public_path__ + "img/home_qr_code.a9f5e34f.png";